<app-nav></app-nav>
<ng-container *ngIf="authService.isLoggedIn()">
    <app-sidebar></app-sidebar>
    <div class="router-wrapper">
        <router-outlet></router-outlet>
    </div>
</ng-container>
<ng-container *ngIf="authService.isEvaluating()">
    <div class="navbar-wrapper">
        <app-login-loading></app-login-loading>
    </div>
</ng-container>
<ng-container *ngIf="authService.isLoggedOut()">
    <div class="navbar-wrapper">
        <app-login></app-login>
    </div>
</ng-container>

